module.exports = __webpack_public_path__ + "img/1440.33fff3e0.jpg";